import styled from '@emotion/styled'
import * as Typeface from '../materials/typeface'

export const H1 = styled('h1')`
  ${Typeface.fontHeading1};
  margin: 0;
`

export const H15 = styled('h1')`
  ${Typeface.fontHeading15};
  margin: 0;
`

export const H2 = styled('h2')`
  ${Typeface.fontHeading2}
  margin: 0;
`

export const H3 = styled('h3')`
  ${Typeface.fontHeading3}
  margin: 0;
`

export const Lead = styled('p')`
  ${Typeface.fontLead};
  margin: 0;
`

export const Byline = styled('h4')`
  ${Typeface.fontByline};
  margin: 0;
`

export function addThinSpacePercentage(x: string) {
  return x.replace('%', '\u202F%')
}
